let forms = {
   add_user: {
      icon: 'fa fa-user',
      title: 'Add User',
      subtitle: 'Provide User Details',
      forms: [
         {
            type: 'text', form_type: 'text', class: 'col-12 col-md-6', model: 'firstName',
            validation: 'required|min:3|max:50', label: 'First Name',
         },
         {
            type: 'text', form_type: 'text', class: 'col-12 col-md-6', model: 'lastName',
            validation: 'required|min:3|max:50', label: 'Last Name',
         },
         {
            type: 'text', form_type: 'email', class: 'col-12', model: 'email',
            validation: 'required|min:3|max:150|email', label: 'Email',
         },
         // {
         //    type: 'mobile', form_type: 'number', class: 'col-12', model: 'phoneNumber',
         //    validation: 'required|min:9|max:9|numeric', label: 'Phone Number', placeholder: 'e.g 723******'
         // },
         {
            type: 'text', form_type: 'password', class: 'col-12 col-md-6', model: 'password',
            validation: 'required|min:5|max:150', label: 'Password',
         },
         {
            type: 'text', form_type: 'password', class: 'col-12 col-md-6', model: 'confirmPassword',
            validation: 'required|min:5|max:150', label: 'Confirm Password',
         },
         {
            type: 'select', class: 'col-12', model: 'userType', filterable: true, clearable: true,
            multiple: false, max_tag_count: 1,options: [
               {val: 'MAKER', label: 'Maker'},
               {val: 'CHECKER', label: 'Checker'},
            ], validation: 'required', label: 'User Type'
         },
      ]
   },
   edit_user: {
      icon: 'fa fa-user',
      title: 'Add User',
      subtitle: 'Provide User Details',
      forms: [
         {
            type: 'text', form_type: 'text', class: 'col-12 col-md-6', model: 'firstName',
            validation: 'required|min:3|max:50', label: 'First Name',
         },
         {
            type: 'text', form_type: 'text', class: 'col-12 col-md-6', model: 'lastName',
            validation: 'required|min:3|max:50', label: 'Last Name',
         },
         {
            type: 'select', class: 'col-12', model: 'userType', filterable: true, clearable: true,
            multiple: false, max_tag_count: 1,options: [
               {val: 'MAKER', label: 'Maker'},
               {val: 'CHECKER', label: 'Checker'},
            ], validation: 'required', label: 'User Type'
         },
      ]
   },
   change_password: {
      icon: 'fa fa-user',
      title: 'Change Password',
      subtitle: 'Provide the old password and a new password',
      forms: [
         {
            type: 'text', form_type: 'password', class: 'col-12', model: 'password',
            validation: 'required|min:5|max:150', label: 'Current Password',
         },
         {
            type: 'text', form_type: 'password', class: 'col-12', model: 'newPassword',
            validation: 'required|min:5|max:150', label: 'New Password',
         },
         {
            type: 'text', form_type: 'password', class: 'col-12', model: 'confirmPassword',
            validation: 'required|min:5|max:150', label: 'Confirm Password',
         },
      ]
   },
}

let tables = {
   users: {
      icon: 'fa fa-users',
      title: 'Admin Users',
      table_fields: [
         { name: 'Names', align: 'l' },
         { name: 'Email', align: 'l' },
         { name: 'User Type', align: 'c' },
         // { name: 'Status', align: 'c' },
         { name: 'Actions', align: 'c' }
      ],
      search_fields: ["email", "firstName", "lastName","userType.name"],
      row_data: [
         { type: 'text', field: 'names', class: 'bold' },
         { type: 'text', field: 'email', class: 'bold' },
         { type: 'text', field: 'role', class: 'bold center' },
         // { type: 'status', field: 'active', class: 'center' },
         {
            type: 'action', field: 'name', class: 'center', icon: '', actions: [
               // {type: 'title', title: 'Actions'},
               { type: 'menu', title: 'Edit', event: 'user:edit', icon: 'fa-edit' },
               { type: 'menu', title: 'Delete', event: 'user:delete', icon: 'fa-trash-alt' },
            ]
         },
      ]
   },
}

export default {
   forms: utils.generateAllFormData(forms),
   tables
}